module.exports = __webpack_public_path__ + "static/media/mw.30c623b6.gif";